module.exports = __webpack_public_path__ + "static/media/personal_email.314f44bc.svg";